'use strict';
var angular = require('angular');
var SettingsService = /** @class */ (function () {
    function SettingsService($http, $q, Auth) {
        'ngInject';
        this._$http = $http;
        this.Auth = Auth;
        // Object to store our user properties
        this.current = null;
        this.pinfoAdd = $q.defer();
    }
    SettingsService.prototype.handleSuccess = function (response) {
        return response;
    };
    SettingsService.prototype.handleError = function (response) {
        return response;
    };
    // TODO: LOOK AT THIS - this is a duplicate the Auth.isLoggedIn method
    SettingsService.prototype.getAccount = function () {
        var request = this._$http.get('api/account', { cache: true });
        return request.then(function (response) {
            if (response.data.error)
                return false;
            if (response.data.response) {
                return response.data.response;
            }
        }, function (err) {
            return false;
        });
    };
    SettingsService.prototype.setPinfoAccount = function (data) {
        this.pinfoAdd.resolve(data);
    };
    SettingsService.prototype.getPinfoAccount = function (data) {
        return this.pinfoAdd.promise;
    };
    SettingsService.prototype.putAccount = function (data) {
        this.Auth.clearAccountCache();
        var request = this._$http.put("api/account/" + data.customerId, data);
        return (request.then(function (data) {
            return (data);
        }, function (err) {
            return (err);
        }));
    };
    return SettingsService;
}());
export default SettingsService;
//# sourceMappingURL=settings.service.js.map